import AppData from '../pacakge/public/const/app_data';
import GameUtil from '../utility/game_util';
import VersionManager from './version_manager';
import ModuleManager from '../framework/core/module_manager';
import EventManager from './event_manager';
import Utility from '../utility/utility';
import ModelData from '../pacakge/public/model_data';
import LoaclStorage from './local_storage';
import AudioManager from './audio_manager';
import LanguageManager from './language_manager';
import LogManager from './log_manager';
import SdkStorage from '../sdk/SdkStorage';
import UserDataManager from './user_manager';
import AppController, { AnalyticsParam } from '../sdk/app_controller';


interface AppVersionDataDetail {
    url ?: string,
    apkUrl ?: string,
    onlyUpdatePlatform ?: string,   //是否限制了特定的平台 ;分割
    onlyAffectVersion ?: string,    //是否限制了特定的版本 ;分割
    force ?: boolean               //是否强制使用这个版本
}

interface AppVersionData {
    bundleId: string,
    version: string
    checkVersion: string,
    data: string,
    info: string,
    forceUpgrade: boolean
}

interface AssetVersionData {
    bundleId: string,
    version: string
    assetVersion: number,
    data: string,
    info: string,
    forceUpgrade: boolean,
    test: boolean,
    ipWhitelist: string,
    accountIdWhitelist: string,
}

export interface AssetVersionDataDetail {
    effectAppVersion: string,
    remoteManifestRoot: string,
    packageUrl: string,
    remoteManifestUrl: string,
    version: string,
    minUpdateInternalAssetVersion?: number,
    onlyUpdatePlatform?: string,
    force?: boolean  //是否强制还原这个版本，一般用于
}


interface VersionDatas {
    updateTime: number
    platform: string
    appVersionData: AppVersionData[],
    assetTestVersioData: AssetVersionData[],
    assetVersioData: AssetVersionData[]
}


export class GameManager {

    static loginServer: string
    static hallServer: string
    static hallServerNotifyServer: string
    static gameServer: string
    static notifyServer: string
    static clubHallServer : string

    static proxyHost: string
    static httpCurApiUrl: string

    private static _gameInited = false

    static curIp: string

    static _lastGetVersionConfigDataTime : number = 0
    static _getVersionConfigIntervalTime = 180000

    static _hideAndroidSplash : boolean

    static testServerHost
    static testServerPort

    static needRebootGame = false

    private static version

    private static __defaultHandler

    static reportConversionEventCount = {}

    static initLog() {
        let handleError = function(...args) {
            if (GameManager.__defaultHandler) {
                GameManager.__defaultHandler(...args)
            }
            let text = "JSError "
            if (args) {
                for (let index = 0; index < args.length; index++) {
                    const element = args[index];
                    if (element == null) {
                        text += '\nnull'
                    } else {
                        if (element instanceof Object) {
                            text += `\n ${JSON.stringify(element)}`
                        } else {
                            text += '\n' + element.toString()
                        }
                    }
                }
            }
            LogManager.instance.log(text)
            if (GameManager.needRebootGame) {  //如果在loadscene过程中处理， 强制重启
                cc.game.restart()
            }
        }
        if (cc.sys.isNative) {
            if (window['__errorHandler']) {
                GameManager.__defaultHandler = window['__errorHandler']
            }
            window['__errorHandler'] = handleError
        } else if (cc.sys.isBrowser) {
            if (window.onerror) {
                GameManager.__defaultHandler = window.onerror
            }
            window.onerror = handleError
        }
        LogManager.instance.log("initLog")
    }

    static getGameServerUrl() {
        if (AppData.testMode) {
            if (this.testServerHost && this.testServerHost != '' && this.testServerPort && this.testServerPort != 0) {
                return 'ws://' + this.testServerHost + ':' + this.testServerPort
            }
        }
        return GameManager.gameServer + ModelData.instance.roleData.id
    }
    
    static setGameServerHostPort(host, port) {
        this.testServerHost = host
        this.testServerPort = port
    }
    

    static reload(url?: string) {
        let openUrl = url ? url : AppData.openUrl
        location.replace(openUrl)
    }

    static openUrl(url) {
        window.location.href = url
    }

    static changeGame(gameName: string) {
        AppData.openAppGameId = gameName;
    }

    static getAppAssetVersion() {
        if (!this.version) {
            if (CC_JSB) {
                this.version = `${AppData.appVersion}(${AppData.internalAssetVersion})_${AppData.appProductVersion}(${AppData.assetVersion})`
            } else {
                this.version = AppData.appProductVersion + "(" + AppData.assetVersion  + ")"
            }
        }
        return this.version
    }

    private static _WebVersionDataProcess(versionData: VersionDatas, fail) {
        if (versionData && versionData.assetVersioData) {
            let datas = versionData.assetVersioData
            let curTime = new Date().getTime()
            for (let index = 0; index < datas.length; index++) {
                const element = datas[index];
                let targetAssetVersion = Utility.parseInt(element.assetVersion)
                // cc.log("WebGetVersionConfigData", targetAssetVersion, AppData.assetVersion)
                if (targetAssetVersion && targetAssetVersion > AppData.assetVersion) {
                    cc.log("资源有更新:", targetAssetVersion)
                    if (element.data.indexOf("http") >= 0 && AppData.openUrl.includes(".com") && AppData.openUrl.indexOf("localhost") < 0) {
                        cc.error("需要更新")
                        ModuleManager.instance.showDialogConfirmCancel("检测到新版本，是否刷新重启？", () => {
                            GameManager.reload(AppData.openUrl)
                        }, null, null, true);
                    }
                    break;
                }
            }
        }
    }

    

    //大版本更新
    private static _AppVersionUpdate(appVersionDataDetail : AppVersionData[], fail) {
        let needUpdate = false
        for (let index = 0; index < appVersionDataDetail.length; index++) {
            const element = appVersionDataDetail[index];
            if (AppData.startCheckGame) {
                if (!element.checkVersion.includes(AppData.appVersion)) {  //不再处于审核状态
                    GameManager.skipCheckGame()
                } 
                return false
            }

            if (!element.bundleId.includes(AppData.bundleId)  || Utility.version_judge(AppData.appVersion, element.version)) {
                continue
            }
            let elementData = Utility.jsonParse<AppVersionDataDetail>(element.data)
            if (elementData && (elementData.onlyUpdatePlatform && !elementData.onlyUpdatePlatform.includes(cc.sys.os))) {
                continue
            }

            if (elementData && (elementData.onlyAffectVersion && !elementData.onlyAffectVersion.includes(AppData.appVersion))) {
                continue
            }
            
            if (elementData && elementData.url && elementData.url.includes("http")) {
                let info = (element.info && element.info != "") ? element.info : LanguageManager.t("public_update_app_new_version", true)
                if (element.forceUpgrade) {
                    ModuleManager.instance.showDialogConfirm(info, () => {
                        cc.sys.openURL(elementData.url)
                    }, null, true);
                } else {
                    ModuleManager.instance.showDialogConfirmCancel(info, () => {
                        cc.sys.openURL(elementData.url)
                    }, null, null, true);
                }
                needUpdate = true
            }
            if (needUpdate) {
                break
            }
        }
        return needUpdate
    }

    //是否限定了bundleID，限定了名字
    private static _AppAssetVersionDataProcess(assetVersioData: AssetVersionData[], callback ?: (needUpdate: boolean, error ?: any) => void) {
        try {
            let needUpdate = false
            for (let index = 0; index < assetVersioData.length; index++) {
                const element = assetVersioData[index];
                element.assetVersion = Utility.parseInt(element.assetVersion)
                cc.log("_AppVersionDataProcess", element)
                if (!element.bundleId.includes(AppData.bundleId)) {
                    continue
                }

                if (element.forceUpgrade && AppData.assetVersion > element.assetVersion) {  //强制还原
                    GameManager.clearReboot()
                    needUpdate = true
                    return needUpdate
                }

                if (AppData.assetVersion >= element.assetVersion) {
                    continue
                }

                let elementData = Utility.jsonParse<AssetVersionDataDetail>(element.data)
                if (elementData && elementData.effectAppVersion) { //统一资源更新
                    if (!elementData.effectAppVersion.includes(AppData.appVersion)) {
                        continue
                    }
                } else if(!element.version.includes(AppData.appVersion)) {
                    continue
                }

                if (element.test) {
                    if (element.ipWhitelist != "" && (!GameManager.curIp || !element.ipWhitelist.includes(GameManager.curIp))) {
                        continue
                    }
                    let uid = ModelData.instance.roleData.id || LoaclStorage.getNumber("LastLoginID", null)
                    if (element.accountIdWhitelist != "" && (!uid || !element.accountIdWhitelist.includes(uid.toString()))) {
                        cc.log("_AppVersionDataProcess Test : ID不吻合")
                        continue
                    }
                    Utility.reportConversionEvent(`upate_version_with_accountId`)
                }

                let updateAssetData : any = elementData 
                if (elementData.effectAppVersion && elementData.remoteManifestRoot) {
                    updateAssetData = {
                        "remoteManifestUrl" : updateAssetData.remoteManifestRoot + `${elementData.version}/project_${AppData.appVersion}_${elementData.version}.manifest`,
                        "version" : elementData.version
                    }
                }

                if (updateAssetData.minUpdateInternalAssetVersion && AppData.internalAssetVersion < updateAssetData.minUpdateInternalAssetVersion) {
                    continue
                }
                if (updateAssetData.onlyUpdatePlatform && !updateAssetData.onlyUpdatePlatform.includes(cc.sys.os)) {
                    continue
                }
                needUpdate = true
                cc.log("资源有更新:", element.assetVersion)
                if (!ModuleManager.instance.moduleHasActive("LoadingModule")) {
                    ModuleManager.instance.showModuleName("LoadingModule")
                }
                Utility.reportConversionEvent(`sys_upate_version_begin`)
                VersionManager.instance.startUpdateVersion(updateAssetData)
                if (needUpdate) {
                    break
                }
            }
            return needUpdate
        } catch (error) {
            cc.error(error)
            if (callback) {
                callback(false, error)
            }
        }
    }

    private static _process


    static getVersionConfigData(callback ?: (needUpdate: boolean, error ?: any) => void) {
        if (!AppData.versionConfigUrl) {
            return
        }

        if (Date.now() - GameManager._lastGetVersionConfigDataTime < GameManager._getVersionConfigIntervalTime) {
            return
        }

        let requestData: IHttpRequestData = {
            baseUrl: AppData.versionConfigUrl + "?time=" + GameUtil.get_now_timestamp(),
            timeOutRequestMax : 1
        }
        GameUtil.http_get(requestData, (versionData : VersionDatas) => {
            try {
                //先检查是否处于审核状态->更新资源->更新大版本
                let needUpdate = false
                if (CC_JSB) {

                    let isCheck = AppData.startCheckGame
                    if (isCheck) {
                        GameManager._AppVersionUpdate(versionData.appVersionData, callback)
                    }

                    if (!AppData.startCheckGame) {                        
                        needUpdate = GameManager._AppAssetVersionDataProcess(versionData.assetTestVersioData, callback)
                        if (!needUpdate) {
                            needUpdate = GameManager._AppAssetVersionDataProcess(versionData.assetVersioData, callback)
                        }
                        if (!needUpdate) {
                            needUpdate = GameManager._AppVersionUpdate(versionData.appVersionData, callback)
                        }
                    }
      
                    if (!needUpdate) {
                        // cc.log("不需要更新")
                        if (isCheck && !AppData.startCheckGame && AppData.alreadyShowHallScene) {
                            GameManager.reboot()
                        }
                        if (ModuleManager.instance.moduleHasActive("LoadingModule")) {
                            EventManager.instance.dispatch("already_up_to_date");
                        }
                    }
                } else {
                    GameManager._WebVersionDataProcess(versionData, callback)
                }
                GameManager._lastGetVersionConfigDataTime = Date.now()
                callback && callback(needUpdate, null)
            } catch (error) {
                if (callback) {
                    callback(false, error)
                }
                cc.error(error)
            }
        }, (error) => { //这里有可能会请求失败，所以需要
            if (callback) {
                callback(false, error)
            }
            cc.error(error)
        })
    }

    static updateVersionInHallScene() {
        if (ModuleManager.instance.moduleHasActive("Hall") || ModuleManager.instance.moduleHasActive("LoginModule") || ModuleManager.instance.moduleHasActive("ClubHallModule")) {
            this.getVersionConfigData()
        }
    }

    static gameStartInit() {
        if (AppData.startCheckGame) {
            this._getVersionConfigIntervalTime = 5000
        }
        cc.game.emit("game_start_init")
    }

    static gameInited() {
        if (!this._gameInited) {
            this._gameInited = true
            cc.game.emit("game_end_init")
        }
        if (AppData.testMode) {
            this._getVersionConfigIntervalTime = 20000
        }
    }

    static setProfilerNode(open) {
        let lableProfiler = cc.find("PROFILER-NODE/RIGHT-PANEL")
        if (lableProfiler) {
            lableProfiler.color = cc.Color.GREEN
            lableProfiler.parent.active = open
        }
    }

    static hideAndroidSplash() {
        if (this._hideAndroidSplash) {
            return
        }
        this._hideAndroidSplash = true
        if (CC_JSB && cc.sys.os === cc.sys.OS_ANDROID) {
            let className = "project/sdk/MainSDKActivity"
            let methodName = "removeSplashImage";               
            let methodSignature = "()V";
            jsb.reflection.callStaticMethod(className, methodName,methodSignature);
        } else if( CC_JSB && cc.sys.os === cc.sys.OS_IOS){
            // let className = "AppController";
            // jsb.reflection.callStaticMethod(className, "removeSplashImage:","");
            AppController.instance.requestNativeFunc("removeSplashImage")
        }   
    }

    static showAndroidSplash() {
        if (CC_JSB && cc.sys.os === cc.sys.OS_ANDROID) {
            let className = "project/sdk/MainSDKActivity"
            let methodName = "showSplashImage";               
            let methodSignature = "()V";
            jsb.reflection.callStaticMethod(className, methodName,methodSignature);
        }      
    }

    static reboot() {
        AudioManager.instance.mute()
        if (CC_JSB) {
            GameManager.needRebootGame = true
            if (Utility.version_judge(AppData.appVersion, "1.2.1")) {
                // GameManager.showAndroidSplash()
                try {
                    cc.director.loadScene("launcher", () => { //TODO：重启前先跳转到空场景，内存回收就正常了。但是如果重启场景出错了，就会卡住流程
                        cc.game.restart()
                    })
                } catch (error) {
                    cc.error("loadScene：", error)
                    cc.game.restart()
                }

            } else {
                setTimeout(() => {
                    cc.game.restart()
                }, 0.1)  //这样是否能减少崩溃呢
            }
        } else {
            window.location.reload()
        }
        LogManager.instance.log("reboot")
    }

    static clearReboot(clearAllLoaclStorage ?: boolean) {
        let __SkipCheckGame = LoaclStorage.getString("__SkipCheckGame")
        let __LastLoginID = LoaclStorage.getString("LastLoginID")
        LoaclStorage.clear()
        if (!clearAllLoaclStorage) {
            if (__SkipCheckGame != null) {
                LoaclStorage.setString("__SkipCheckGame", __SkipCheckGame)
            }
            if (__LastLoginID != null) {
                LoaclStorage.setString("LastLoginID", __LastLoginID)
            }
        }
        if (CC_JSB) {
            jsb.fileUtils.removeDirectory(jsb.fileUtils.getWritablePath() + 'remote-assets');
        } 
        GameManager.reboot()
    }

    static skipCheckGame() {
        LoaclStorage.setString("__SkipCheckGame", AppData.appVersion)
        AppData.startCheckGame = false
    }

    static reset() {
        GameManager._lastGetVersionConfigDataTime = 0
    }

    static logout() {
        GameManager._lastGetVersionConfigDataTime = 0
        GameManager.reportConversionEventCount = {}
        ModelData.instance.reset()
        SdkStorage.clearLoginToken();
        AppData.appDownloadUrl = null
        AppData.promoteUrl = null
        ModelData.instance.gameDataShow = null
        UserDataManager.clearPlayerDataById(ModelData.instance.roleData.id)
        UserDataManager.clearCurrencyData()
        UserDataManager.clearGetCurrencyDataState()
    }

    //转化事件，会立刻上报
    static reportConversionEvent(eventName, eventValue = 1) { 
        let eventCount : number = GameManager.reportConversionEventCount[eventName] || 1
        if (eventCount > 2) {
            // cc.error("频繁的上报没必要")
            return
        }
        GameManager.reportConversionEventCount[eventName] = eventCount + 1
        GameManager.reportEffect(eventName, eventValue)
    }

    //一小时上报一次
    static reportEffect(action, analyticsParam?) {
        let value: AnalyticsParam = {
            value: analyticsParam,
            "currency": "THB",
            "uid": ModelData.instance.userId
        }
        Utility.reportEvent(action, value)
    }

}